import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { zapierQueryKeys } from "./zapierQueryKeys";

export const useQueryZapierGetIntegrationStatus = ({
  api,
  refetchOnWindowFocus,
  clubId,
  enabled,
}: {
  api: ApiType;
  refetchOnWindowFocus?: boolean;
  clubId: number;
  enabled: boolean;
}) =>
  useQuery({
    queryKey: zapierQueryKeys.getIntegrationStatus(clubId),
    queryFn: async () => (await api.zapierApi.getIntegrationStatus()).data,
    refetchOnWindowFocus,
    enabled,
  });
